import { Kind, SchemaOptions, TSchema, Type, TypeRegistry } from '@sinclair/typebox';

/**
 * @note Working solution for string unions where TypeRegistry.Set should be top level
 * Brings much better string union presentation in Readme
 * https://github.com/xddq/schema2typebox/issues/16
 */
TypeRegistry.Set('StringEnum', (schema: TSchema, value) => schema.enum.includes(value));

export const StringEnum = <T extends string[]>(values: [...T], options: SchemaOptions = {}) =>
  Type.Unsafe<T[number]>({
    ...options,
    [Kind]: 'StringEnum',
    type: 'string',
    enum: values,
  });

export const NumberEnum = <T extends number[]>(values: [...T], options: SchemaOptions = {}) =>
  Type.Unsafe<T[number]>({
    ...options,
    // Use TypeBox's native union kind so Value.Convert can coerce numeric query strings before validation.
    // Keep type and enum at the top level for OpenAPI documentation renderers.
    [Kind]: 'Union',
    type: 'number',
    enum: values,
    anyOf: values.map((value) => Type.Literal(value)),
  });

TypeRegistry.Set('Buffer', (_, value) => Buffer.isBuffer(value));

export const TBuffer = Type.Unsafe<Buffer>({ [Kind]: 'Buffer' });

// export type OptionsWithDocOnly<Options extends SchemaOptions> = Options & {
//   'x-docs-only'?: Options;
// };
